import $ from "jquery";
import { courseReportSummaryFilters } from "./courseReportSummaryFilters";
import { dataaccess } from "../dataaccess/dataContext";
import { forms } from "../framework/forms";

let courseTable;
let courseTableFees;
const tableColumns = ["CourseId", "CourseDate", "CourseStatus", "PassRate", "CourseSite", "CourseCity", "CourseState", "CourseApprovalArea", "CourseRegion", "PhysicianCount", "ResidentCount", "AppCount", "MedicalStudentCount", "OtherCount", "CourseCommercialSupport", "DocumentName", "TotalFacultyCount", "RegistrationFee"];
const tableFeesColumns = ["CourseId", "AdvertisingExhibitIncome", "EducationalGrant", "GovernmentMonetaryGrants", "TotalPrivateMonetaryDonations", "RegistrationFee"];
let dataSet1 = [];
let dataSet2 = [];
let currentPage = 1;
let pageSize = 20;
let totalMatchedRecords = 0;
let hasNextPage;
let sort = {};

function init() {
    setEvents();
    buildTable();
}
function setEvents() {
    $("#btnApplyFilters").click(applyFilters);
    $("#btnDownloadExcel").click(downloadReport);
    $("#next").click(goNextPage);
    $("#previous").click(goPreviousPage);
    $(".sorting, .sorting_asc, .sorting_desc").click(applySort);
    $("#selectCourseType").change(function () {
        const courseTypeId = $("#selectCourseType").val();
        const programId = $("#programId").val();
        getCourseLengths(courseTypeId);
        getCourseEditions(courseTypeId, programId);
    });
}

function downloadReport() {
    if (!parametersValid()) {
        return;
    }
    let source = $(this).attr("href");

    if (!source.endsWith("?")) {
        source += "?";
        let index = source.indexOf("?");
        source = source.substring(0, index + 1);
    }

    const sourceWithParams = source += $.param(courseReportSummaryFilters.getQueryStringFilters()).replace(/%5B%5D/g, "");

    $(this).attr("href", sourceWithParams);
}

function goNextPage() {
    if (!hasNextPage) return;
    currentPage++;
    applyFilters(courseReportSummaryFilters.getFilters(), false);
}
function goPreviousPage() {
    if (currentPage === 1) return;
    currentPage--;
    applyFilters(courseReportSummaryFilters.getFilters(), false);
}

function buildDataSet(courses) {
    dataSet1 = [];
    dataSet2 = [];
    if (!courses || !courses.length) { return; }
    for (let courseRecord of courses) {
        dataSet1.push([
            courseRecord.courseId,
            courseRecord.courseDate,
            courseRecord.courseStatus,
            courseRecord.passRate,
            courseRecord.courseSite,
            courseRecord.courseCity,
            courseRecord.courseState,
            courseRecord.courseApprovalArea,
            courseRecord.courseRegion,
            courseRecord.physicianCount,
            courseRecord.residentCount,
            courseRecord.appCount,
            courseRecord.medicalStudentCount,
            courseRecord.otherCount,
            courseRecord.courseCommercialSupport,
            courseRecord.documentLink
        ]);
        dataSet2.push([
            courseRecord.courseId,
            courseRecord.advertisingExhibitIncome,
            courseRecord.educationalGrant,
            courseRecord.governmentMonetaryGrants,
            courseRecord.totalPrivateMonetaryDonations,
            courseRecord.registrationFee
        ]);
    }
    hasNextPage = (currentPage * pageSize) < totalMatchedRecords;
    setNextPrevButtonEnabled();
}

function buildTable() {
    courseTable = $("#courseSummaryTable").DataTable({
        "serverSide": false, // for process server side
        "filter": false, // this is for disable filter (search box)
        //"orderMulti": false, // for disable multiple column at once
        "data": dataSet1,
        "bLengthChange": false,
        "bPaginate": true,
        "PageLength": 20,
        "bInfo": false,
        "ordering": false,
        "columnDefs":
            [
                {
                    "targets": 0,
                    "name": "CourseId"
                },
                {
                    "targets": 1,
                    "name": "CourseDate"
                },
                {
                    "targets": 2,
                    "name": "CourseStatus"
                },
                {
                    "targets": 3,
                    "name": "PassRate",
                    "render": $.fn.dataTable.render.number(null, '.', 0,null,'%')
                },
                {
                    "targets": 4,
                    "name": "CourseSite"
                },
                {
                    "targets": 5,
                    "name": "CourseCity"
                },
                {
                    "targets": 6,
                    "name": "CourseState"
                },
                {
                    "targets": 7,
                    "name": "CourseApprovalArea"
                },
                {
                    "targets": 8,
                    "name": "CourseRegion"
                },
                {
                    "targets": 9,
                    "name": "PhysicianCount",
                    "render": $.fn.dataTable.render.number(',', '.', 0)
                },
                {
                    "targets": 10,
                    "name": "ResidentCount",
                    "render": $.fn.dataTable.render.number(',', '.', 0)
                },
                {
                    "targets": 11,
                    "name": "AppCount",
                    "render": $.fn.dataTable.render.number(',', '.', 0)
                },
                {
                    "targets": 12,
                    "name": "MedicalStudentCount",
                    "render": $.fn.dataTable.render.number(',', '.', 0)
                },
                {
                    "targets": 13,
                    "name": "OtherCount",
                    "render": $.fn.dataTable.render.number(',', '.', 0)
                },
                {
                    "targets": 14,
                    "name": "CourseCommercialSupport"
                },
                {
                    "targets": 15,
                    "name": "DocumentLink"
                }
            ]
    });

    courseTableFees = $("#courseSummaryFeesTable").DataTable({
        "serverSide": false, // for process server side
        "filter": false, // this is for disable filter (search box)
        //"orderMulti": false, // for disable multiple column at once
        "data": dataSet2,
        "bLengthChange": false,
        "bPaginate": true,
        "PageLength": 20,
        "bInfo": false,
        "ordering": false,
        "columnDefs":
            [
                {
                    "targets": 0,
                    "name": "CourseId"
                },
                {
                    "targets": 1,
                    "name": "AdvertisingExhibitIncome",
                    "render": $.fn.dataTable.render.number(',', '.', 2, '$')
                },
                {
                    "targets": 2,
                    "name": "EducationalGrant",
                    "render": $.fn.dataTable.render.number(',', '.', 2, '$')
                },
                {
                    "targets": 3,
                    "name": "GovernmentMonetaryGrants",
                    "render": $.fn.dataTable.render.number(',', '.', 2, '$')
                },
                {
                    "targets": 4,
                    "name": "TotalPrivateMonetaryDonations",
                    "render": $.fn.dataTable.render.number(',', '.', 2, '$')
                },
                {
                    "targets": 5,
                    "name": "RegistrationFee",
                    "render": $.fn.dataTable.render.number(',', '.', 2, '$')
                }
            ]
    });
}
function setNextPrevButtonEnabled() {
    if (!hasNextPage) {
        $("#next").addClass("disabled");
    } else {
        $("#next").removeClass("disabled");
    }
    if (currentPage === 1) {
        $("#previous").addClass("disabled");
    } else {
        $("#previous").removeClass("disabled");
    }
}
function applyFilters(isNewSearch) {
    if (!parametersValid()) {
        return;
    }
    // Resetting current page number to 1 as it is fresh new search criteria(user clicked on the "Run Report" button)
    if (arguments.length === 1 || (arguments[1] && isNewSearch))
        currentPage = 1;

    forms.showSpinner();
    getData().then(function (data) {
        pageSize = data.pageSize;
        totalMatchedRecords = data.rowCount;
        if (data.results)
            buildDataSet(data.results);
        else
            buildDataSet(data);
        courseTable.clear();
        courseTable.rows.add(dataSet1).draw();
        courseTableFees.clear();
        courseTableFees.rows.add(dataSet2).draw();
        setNextPrevButtonEnabled();
        forms.hideSpinner();
    });
}
function applySort(e) {
    const asc = $(this).hasClass("sorting") || $(this).hasClass("sorting_desc");
    $(".sorting, .sorting_asc, .sorting_desc").removeClass()
        .addClass("sorting");

    if (asc) {
        $(this).removeClass("sorting").removeClass("sorting_desc").addClass("sorting_asc");
    } else {
        $(this).removeClass("sorting").removeClass("sorting_asc").addClass("sorting_desc");
    }
    $(".sorting, .sorting_asc, .sorting_desc").not($(this)).removeClass(".sorting_asc").removeClass(".sorting_desc")
        .addClass("sorting");
    sort = {
        column: tableColumns[courseTable.column(this).index()],
        desc: $(this).hasClass("sorting_desc")
    };
    applyFilters(false);
}
function getData() {
    const filters = courseReportSummaryFilters.getFilters();
    filters.desc = sort.desc;
    filters.sortColumn = sort.column || "";
    return dataaccess.post({ url: "/CourseReportSummary/getCourseReport/" + currentPage, data: filters });
}
function getCourseLengths(courseTypeId) {
    if (courseTypeId > 0) {
        dataaccess.get({ url: "/Course/GetCourseLengths/" + courseTypeId }).done(function (results) {
            $("#selectCourseLength option")
                .not(":first")
                .remove();
            let i;
            for (i = 0; i < results.length; i++) {
                $("#selectCourseLength").append(
                    "<option value=" +
                    results[i].id +
                    " data-schedule-days='" +
                    results[i].scheduleDays +
                    "'>" +
                    results[i].description +
                    "</option>"
                );
            }
        });
    }
}
function getCourseEditions(courseTypeId, programId) {
    if (courseTypeId > 0 && programId > 0) {
        dataaccess
            .get({
                url:
                    "/Course/GetCourseEditions/CourseType/" + courseTypeId + "/Program/" + programId
            })
            .done(function (results) {
                $("#selectCourseEdition option")
                    .not(":first")
                    .remove();
                let i;
                for (i = 0; i < results.length; i++) {
                    $("#selectCourseEdition").append(
                        "<option value=" +
                        results[i].id +
                        ">" +
                        results[i].description +
                        "</option>"
                    );
                }
            });
    }
}

function parametersValid() {
    let result = true;
    let filters = courseReportSummaryFilters.getFilters();
    $("#courseTypeValidation").addClass("hidden");
    $("#courseLengthValidation").addClass("hidden");
    $("#courseEditionValidation").addClass("hidden");
    if (filters.courseTypeId === null) {
        $("#courseTypeValidation").removeClass("hidden");
        result = false;
    }
    if (filters.courseLengthId === null) {
        $("#courseLengthValidation").removeClass("hidden");
        result = false;
    }
    if (filters.courseEditionId === null) {
        $("#courseEditionValidation").removeClass("hidden");
        result = false;
    }
    return result;
}
export const courseReportSummary = {
    init: init
};